import { url } from '../static/env';

export async function fetchBuhServiceStatus(userId, companyId) {
    const response = await fetch(`${url}/buh-service-status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            user_id: userId,
            company_id: companyId || undefined,
        }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || 'Не удалось получить статус обслуживания');
    }
    return data;
}
